import './App.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import AppRoutes from './routes';
import { IState } from './types';
import { withDefaultStyles } from './utils/material-ui/hoc';

class App extends React.Component<IState, IState> {
  public render() {
    return (
      <div>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(connect(
  mapStateToProps
)(App));



// WEBPACK FOOTER //
// ./src/App.tsx